import StringUtil from 'utils/string-util'

export const STATUS = {
  PENDING   : 'pending',
  COMPLETED : 'completed'
}

export const TRANFSER_METHOD = {
  CASH        : 'cash',
  CREDIT_CARD : 'credit_card',
  KREDIVO     : 'kredivo',
  GOPAY       : 'gopay'
}

export const PER_PAGE = {
  '10' : '10',
  '25' : '25',
  '50' : '50'
}

export const STATUS_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  ...Object.keys(STATUS).map((key) => (
    {
      label : StringUtil.titleCase(key),
      value : STATUS[key]
    }
  ))
]

export const TRANSFER_OPTIONS = [
  {
    'label' : 'All',
    'value' : ''
  },
  ...Object.keys(TRANFSER_METHOD).map((key) => (
    {
      label : StringUtil.titleCase(key),
      value : TRANFSER_METHOD[key]
    }
  ))
]

export const PER_PAGE_OPTIONS = Object.keys(PER_PAGE).map((key) => (
  {
    label : StringUtil.titleCase(key),
    value : PER_PAGE[key]
  }
))

export const DEBIT_BANKS = [
  {
    value : '',
    label : 'Select Bank'
  },
  {
    value : 1,
    label : 'BCA'
  },
  {
    value : 2,
    label : 'Mandiri'
  },
  {
    value : 3,
    label : 'BNI'
  },
  {
    value : 4,
    label : 'BRI'
  }
]